import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setSidebar } from 'redux/reducers/app';
import { getCurrentDesign, getDesigns } from 'redux/selectors/design';
import { trackEvent } from 'redux/reducers/user';

import { Notification } from 'components';

import styles from './styles.scss';

@connect(
  state => ({
    notifications: state.getIn(['app', 'notifications'], null),
    designId: getCurrentDesign(state),
    designs: getDesigns(state),
  }),
  {
    setSidebar,
    trackEvent,
  }
)
export default class Notifications extends React.PureComponent {
  static contextTypes = {
    orderId: PropTypes.string,
  };

  toOrder = e => {
    this.props.setSidebar('order');
  };

  componentDidUpdate(prevProps) {
    const { showReadyToOrder, trackEvent } = this.props;

    if (showReadyToOrder && prevProps.showReadyToOrder !== showReadyToOrder) {
      trackEvent('product_ready', {});
    }
  }

  render() {
    const { notifications, showReadyToOrder = false } = this.props;

    return (
      <div className={styles.notifications}>
        {notifications
          ? notifications.map((message, key) => <Notification key={key} message={message} />).toArray()
          : null}

        {showReadyToOrder ? (
          <Notification
            message={kroostApp.strings.notificationReady}
            cta={{
              children: kroostApp.strings.notificationGoToOrder,
              onClick: this.toOrder,
            }}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/notifications/index.js